// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2q35a","clinicsSelect":"TableHeading_clinicsSelect__1mmjg"};